const AboutUs = () => {
  return (
    <div className="about-us" id="o-nama">
      <div className="about-us-all-page">
        <div className="about-us-title">Consulting Trio Tim d.o.o.</div>
        <div className="about-us-page">
          <div className="about-us-left">
            <img
              src="/images/logo.png"
              className="ison-about-us-left"
              alt="triotim"
            />
          </div>
          <div className="about-us-right">
            <div className="about-us-right-all-text">
              <div className="about-us-right-text">
                Consulting Trio Tim je specijalizovana kompanija za izradu
                Procene rizika od katastrofa i Plana zaštite i spasavanja.
              </div>

              <div className="about-us-right-text">
                Osnovana je sa idejom da pruži doprinos u teorijskom i
                praktičnom pristupu smanjenja rizika od katastrofa.
              </div>

              <div className="about-us-right-text">
                Kompanija u kojoj mladost, entuzijazam i stručnost čine srž
                misije - unapređenje sistema bezbednosti u našoj zemlji.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
